import {
  anchor,
  characterCount,
  commonNodeCommands,
  contentDiff,
  doc,
  dropcursor,
  focus,
  keymap,
  keymapOverride,
  link,
  overlay,
  placeholder,
  ricosStyles,
  styles,
  text,
  trailingNode,
  uniqueId,
} from 'wix-tiptap-extensions';

import { commands } from '../../core-commands';

const isWindowDefined = typeof window !== 'undefined';

export const coreConfigs = [
  placeholder,
  commonNodeCommands,
  characterCount,
  ricosStyles,
  overlay,
  focus,
  styles,
  text,
  doc,
  trailingNode,
  uniqueId,
  commands,
  link,
  anchor,
  dropcursor,
  keymap,
  keymapOverride,
  ...(isWindowDefined && !/skipContentDiff/i.test(window.location.search) ? [contentDiff] : []),
];
